import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAssetPath } from '../utils/assetHelper';
import './SettingsWalletPage.scss';

interface Wallet {
  id: string;
  name: string;
  icon: string;
  isEnabled: boolean;
  isDefault?: boolean;
  color?: string;
}

const SettingsWalletPage: React.FC = () => {
  // State for wallets
  const [wallets, setWallets] = useState<Wallet[]>([
    { 
      id: 'phantom', 
      name: 'Phantom Wallet', 
      icon: 'phantom-wallet-icon.svg', 
      isEnabled: true, 
      isDefault: true,
      color: 'purple'
    },
    { 
      id: 'metamask', 
      name: 'MetaMask Wallet', 
      icon: 'metamask.svg', 
      isEnabled: true,
      color: 'orange'
    },
    { 
      id: 'coinbase', 
      name: 'Coinbase Wallet', 
      icon: 'coinbase.svg', 
      isEnabled: false
    }
  ]);

  // Handle wallet toggle
  const handleWalletToggle = (id: string) => {
    setWallets(prev => 
      prev.map(wallet => 
        wallet.id === id ? { ...wallet, isEnabled: !wallet.isEnabled } : wallet
      )
    );
  };

  // Set document title on component mount
  useEffect(() => {
    document.title = 'Settings - Wallet | Phantom Clash';
    
    // Initialize tooltips if Bootstrap is available
    if ((window as any).bootstrap) {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
      });
    }
  }, []);

  return (
    <>
      {/* Page Menu */}
      <div className="c-page-menu">
        <ul>
          <li><Link to="/settings-profile">Profile</Link></li>
          <li><Link to="/settings-notifications">Notifications</Link></li>
          <li className="active"><Link to="/settings-wallet">Wallet</Link></li>
          <li><Link to="/settings-security">Security</Link></li>
          <li><Link to="/settings-privacy">Privacy</Link></li>
          <li><Link to="/settings-display">Theme & Display</Link></li>
          <li><Link to="/settings-advanced">Advanced Settings</Link></li>
        </ul>
      </div>

      <div className="d-block w-100">
        <div className="box position-relative z-1 overflow-hidden mt-2">
          <div className="c-content-box c-content-box--xspadding c-content-box--setting-width">
            <div className="c-content-box__title">
              <h1 style={{ backgroundImage: 'none' }}><i className="bi bi-wallet-fill"></i> Wallet Management</h1>
              <div className="c-content-box__title-info"></div>
            </div>
            <div className="c-content-box__content">
              <h5 className="c-content-mini-title gray">Manage and secure your connected wallets</h5>
              
              {/* Wallet Cards */}
              <div className="d-flex flex-md-row flex-column align-items-center gap-2">
                {wallets.map(wallet => (
                  <div 
                    key={wallet.id} 
                    className={`c-settings-card ${wallet.color || ''}`}
                  >
                    {wallet.isDefault && (
                      <span className="c-settings-card__default"><i className="bi bi-check"></i> Default</span>
                    )}
                    <a href="#" className="c-settings-card__hover"><i className="bi bi-three-dots"></i></a>
                    <div className="c-settings-card__icon">
                      <img src={getAssetPath(`assets/images/${wallet.icon}`)} alt={wallet.name} />
                    </div>
                    <div className="c-settings-card__text">
                      <h4 className="mb-3">{wallet.name}</h4>
                      <label className="c-switch" id={wallet.id}>
                        <input 
                          type="checkbox" 
                          className="c-switch-input" 
                          checked={wallet.isEnabled}
                          onChange={() => handleWalletToggle(wallet.id)}
                        />
                        <span className="c-switch-label" data-on="On" data-off="Off"></span>
                        <span className="c-switch-handle"></span>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Connect New Wallet Button */}
              <a 
                href="" 
                className="c-button c-button--bordered c-button--xl c-button--grayicon mt-4"
              >
                <i className="bi bi-plus-circle-fill"></i> Connect New Wallet
              </a>
              
              {/* Whitelisted Addresses */}
              <div className="c-divider mt-4 pt-4">
                <div className="c-stats-card light-blue">
                  <div className="c-stats-card__icon">
                    <img src={getAssetPath("assets/images/sol-icon.svg")} alt="SOL" />
                  </div>
                  <div className="c-stats-card__text">
                    <h4>Whitelisted</h4>
                    <div className="c-stats-card__text-count align-items-end">
                      47 <h5 className="mb-1 ms-1">Addresses</h5>
                    </div>
                  </div>
                  <div className="c-stats-card__line"></div>
                </div>
              </div>
              
              {/* Action Buttons */}
              <div className="d-flex flex-md-row flex-column align-items-center">
                <a 
                  href="" 
                  className="c-button c-button--bordered c-button--xl c-button--grayicon mt-4 me-2"
                >
                  <i className="bi bi-plus-circle-fill"></i> Add Address
                </a>
                <a 
                  href="" 
                  className="c-button c-button--bordered c-button--xl c-button--grayicon mt-4"
                >
                  <i className="bi bi-eye-fill"></i> View All
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsWalletPage; 